// extracted by mini-css-extract-plugin
export var button = "ShareButtons-module--button--endvd";
export var container = "ShareButtons-module--container--qtSsl";
export var icon = "ShareButtons-module--icon--QGv3u";
export var link = "ShareButtons-module--link--cYzKY";
export var shareButton = "ShareButtons-module--shareButton--9VsyK";